var _effectorFileName = "/src/page-content/privacy-policy/model.ts";
import { pagesPath } from '@/shared/config/$path';
import { declarePage } from '@/shared/lib/effector/page';
export const privacyPolicyPage = declarePage({
  pageType: pagesPath.$url().pathname
});